define('../app/fukit/model/cayuse.task.list.model',['require','exports','module','./base.model','../collection/base.collection'],function(require, exports, module) {
  //prettier-ignore
  var BaseModel      = require('./base.model'),
      BaseCollection = require('../collection/base.collection');

  var CayuseTaskListModel = BaseModel.extend({
    radioRequests: {
      'models CayuseTaskListModel': '@constructor',
    },

    // To keep things abstract, products needs to pass the details for the links in the task list view.
    // You will need to override these methods locally in the app to do that.
    getTaskRouteOptions: function() {
      return;
    },

    getForRouteOptions: function() {
      return;
    },
  });
  module.exports = CayuseTaskListModel;
});

